module.exports = __webpack_public_path__ + "img/0010.c8ec5c08.jpg";